export default __webpack_public_path__ + "static/media/AcceleronsGallery_19.3b65f3d8.JPG";